import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Utilisateur } from 'app/models/Utilisateur';
import { environment } from 'environments/environment';
import { MonoTypeOperatorFunction, Observable, OperatorFunction } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UtilisateurService {
  pipe(
    arg0: MonoTypeOperatorFunction<unknown>,
    arg1: OperatorFunction<Utilisateur, Blob>,
  ) {
    throw new Error('Method not implemented.');
  }
  serveur_name = environment.serveur_name;
  host_name = environment.host_name;

  private utilisateursUrl = this.host_name + '/api/users';
  private publicationsUrl = this.host_name + '/api/publications';

  constructor(private http: HttpClient) {}

  recupererTout(): Observable<Utilisateur[]> {
    return this.http.get<Utilisateur[]>(this.utilisateursUrl);
  }

  enregistrer(utilisateur: Object): Observable<Object> {
    return this.http.post<Utilisateur[]>(this.utilisateursUrl, utilisateur);
  }
  mettreAJour(utilisateur: Utilisateur): Observable<Utilisateur[]> {
    return this.http.put<Utilisateur[]>(
      `${this.utilisateursUrl}/${utilisateur.userId}`,
      utilisateur,
    );
  }
  getUtilisateur(id: string): Observable<Utilisateur> {
    return this.http.get<Utilisateur>(`${this.utilisateursUrl}/id/${id}`);
  }
  getUtilisateurByUsername(username: string): Observable<Utilisateur[]> {
    return this.http.get<Utilisateur[]>(
      `${this.utilisateursUrl}/username/${username}`,
    );
  }
  mettreAJourUtilisateur(id: string, value: any) {
    return this.http.put(`${this.utilisateursUrl}/${id}`, value);
  }
  supprimerUtilisateur(id: string): Observable<any> {
    return this.http.delete(`${this.utilisateursUrl}/${id}`);
  }
  getPublicationUtilisateur(idUtilisateur: string) {
    return this.http.get(
      `${this.publicationsUrl}/idUtilisateur/${idUtilisateur}`,
    );
  }
  getGroupeUtilisateur(groupe: string) {
    return this.http.get(`${this.utilisateursUrl}/groupe/${groupe}`);
  }
  checkUserExists(email: string): Observable<boolean> {
    // Make a request to your backend to check for user existence.
    // Assuming your API endpoint returns a boolean indicating whether the user exists.

    return this.http.get<boolean>(`${this.utilisateursUrl}/email/${email}`);
  }
}
